export const formatLocalDateTime = (epochSeconds) => {
  if (!epochSeconds) return "";

  return new Date(epochSeconds * 1000)
    .toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
    .replace(",", "");
};
